import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/snackbar/snackbar.component.js'

const tagName = 'dap-ds-snackbar'

/**
 * `dap-ds-snackbar`
 * @summary The Snackbar is a container of sliding messages.
 * @element dap-ds-snackbar
 * @title - Snackbar
 *
 * @csspart host - The host element
 * @csspart message - The message part of the snackbar
 * @csspart message-base - The base part of the message
 * @csspart message-text - The text part of the message
 * @csspart message-closebutton - The close button part of the message
 * @csspart message-close-icon - The close icon part of the message
 * @csspart message-actions - The actions part of the message
 *
 * @cssproperty --dds-snackbar-spacing - Spacing used for positioning the snackbar (default: var(--dds-spacing-400))
 * @cssproperty --dds-snackbar-z-index - Z-index of the snackbar container (default: 10000)
 * @cssproperty --dds-snackbar-pointer-events - Pointer events behavior for the snackbar (default: auto)
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSSnackbar',
})

export default reactWrapper
